<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid">
      <!-- Autre Autorisation de pratique -->
      <fieldset>
        <legend class="text-h6 text-sm-h5">Autre(s) autorisation(s) de pratique</legend>
        <section class="body-2">
          <p class="mentionLegal">
            <RessourceInfoBulle code="UNI-AAP-1" />
          </p>
        </section>

        <!-- NumeroDePermisDePsychotherapeuteSiApplicable -->
        <v-text-field
          v-model="getAutresAutorisationsDePratique.numeroDePermisDePsychotherapeuteSiApplicable"
          label="Numéro de permis de psychothérapeute, si applicable"
        ></v-text-field>

        <v-autocomplete
          v-model="getAutresAutorisationsDePratique.membreDUnAutreOrdre"
          :item-text="itemText"
          :item-value="itemValue"
          :items="listesAutresOrdres"
          clearable
          label="Membre d'un ou plusieurs ordres du Québec (n.b. si vous êtes uniquement psychothérapeute, vous n'êtes pas considéré être membre de l'Ordre des psychologues)"
          multiple
          return-object
        ></v-autocomplete>

        <!-- Citoyennete -->
        <v-autocomplete
          v-model="getAutresAutorisationsDePratique.instancesReglementairesEnTravailSocialHorsQuebec"
          :item-text="itemText"
          :item-value="itemValue"
          :items="listesInstancesReglementaires"
          clearable
          label="Instances règlementaires en Travail social hors Québec"
          multiple
          return-object
        ></v-autocomplete>
      </fieldset>
    </v-form>
    <div class="text-right">
      <v-btn color="primary" :disabled="!valid" @click="saveAndExit()">Sauvegarder et fermer</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Loader from "../Loader"
import { getExtranetUrl } from "@/utils/stringUtils"

export default {
  components: {
    Loader: Loader,
  },
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      overlay: false,
      messageSelector: "",
      valid: false,
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      contactId: "Unitaire/GET_CONTACTID",
      getAutresAutorisationsDePratique: "AutresAutorisationsDePratique/GET_AUTRESAUTORISATIONDEPRATIQUES",
      listesAutresOrdres: "Catalogue/GET_AUTRESORDRE",
      listesInstancesReglementaires: "Catalogue/GET_INSTANCESREGLEMENTAIRES",
      getFormations: "FormationInitiale/GET_FORMATIONS",
    }),
  },
  created() {
    this.fetchItems()
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getAutresAutorisationsDePratiqueByContactId: "AutresAutorisationsDePratique/getAutresAutorisationsDePratiqueByContactId",
      createAutresAutorisationsDePratique: "AutresAutorisationsDePratique/createAutresAutorisationsDePratique",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [
          this.getCatalogue(this.$cataloguesDesc.membreAutresOrdres),
          this.getCatalogue(this.$cataloguesDesc.instancesReglementaires),
        ]

        if (this.contactId) {
          requests.push(this.getAutresAutorisationsDePratiqueByContactId(this.contactId))
        }

        await Promise.all(requests)

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    saveAndExit() {
      this.save()
    },
    async save() {
      this.validateForm()
      if (!(this.valid && this.getAutresAutorisationsDePratique)) {
        return
      }

      this.messageSelector = "Save"
      this.overlay = true

      // validation données
      if (this.contactId) {
        this.getAutresAutorisationsDePratique.pp = this.contactId
      }

      this.getAutresAutorisationsDePratique.active = true
      this.getAutresAutorisationsDePratique.demandeAdmission = null
      this.getAutresAutorisationsDePratique.demandeInscription = null

      // envoi
      this.createAutresAutorisationsDePratique(this.getAutresAutorisationsDePratique).then(() => {
        this.redirect()
      })
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    validateForm(resetValidation = false) {
      this.valid =
        (this.$refs.form?.validate() || false) &&
        // check lists is not null
        !!this.getAutresAutorisationsDePratique

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    redirect() {
      window.top.location.href = getExtranetUrl(process.env.VUE_APP_PROFIL_XTRANET)
    },
  },
}
</script>

<style></style>